export const EVENT_SIMPLE_TABLE_ITEM_CLICK = 'EVENT_SIMPLE_TABLE_ITEM_CLICK';
export const EVENT_SIMPLE_TABLE_SKIP_BUTTON_CLICK = 'EVENT_SIMPLE_TABLE_SKIP_BUTTON_CLICK';
export const EVENT_SIMPLE_TABLE_LONG_SURVEY_CLICK = 'EVENT_SIMPLE_TABLE_LONG_SURVEY_CLICK';
export const EVENT_SURVEY_FORM_SUBMIT_CLICK = 'EVENT_SURVEY_FORM_SUBMIT_CLICK';
export const EVENT_SURVEY_FORM_UPDATE = 'EVENT_SURVEY_FORM_UPDATE';

export const EVENT_STEP_CLICK = 'EVENT_STEP_CLICK';
export const EVENT_CONTENT_LEFT_QUESTION = 'EVENT_CONTENT_LEFT_QUESTION';
export const EVENT_CONTENT_LEFT_QUESTION_PREVIEW = 'EVENT_CONTENT_LEFT_QUESTION_PREVIEW';
export const EVENT_CONTENT_LEFT_CANCEL_SURVEY = 'EVENT_CONTENT_LEFT_CANCEL_SURVEY';
export const EVENT_CONTENT_LEFT_CANCEL_QUESTION = 'EVENT_CONTENT_LEFT_CANCEL_QUESTION';
export const EVENT_CONTENT_RIGHT_QUESTION = 'EVENT_CONTENT_RIGHT_QUESTION';
export const EVENT_CONTENT_LEFT_WHEN_QUESTION_TYPE_CLICK = 'EVENT_CONTENT_LEFT_WHEN_QUESTION_TYPE_CLICK';
export const EVENT_CONTENT_LEFT_UPDATE_SELECTED_CHANGE_MODEL = 'EVENT_CONTENT_LEFT_UPDATE_SELECTED_CHANGE_MODEL';
export const EVENT_CONTENT_LEFT_WHEN_CREATE_GROUP_CLICK = 'EVENT_CONTENT_LEFT_WHEN_CREATE_GROUP_CLICK';
export const EVENT_GLOBAL_UPDATE_QUESTIONS = 'EVENT_GLOBAL_UPDATE_QUESTIONS';
export const EVENT_BUILDER_SELECTED_QUESTION_IN_GROUP = 'EVENT_BUILDER_SELECTED_QUESTION_IN_GROUP';
export const EVENT_BUILDER_TRY_TO_EDIT_ANOTHER_QUESTION = 'EVENT_BUILDER_TRY_TO_EDIT_ANOTHER_QUESTION';
export const EVENT_BUILDER_TRY_TO_ADD_QUESTION_IN_GROUP = 'EVENT_BUILDER_TRY_TO_ADD_QUESTION_IN_GROUP';
export const EVENT_CONTENT_RIGHT_SUBMIT_CLICK = 'EVENT_CONTENT_RIGHT_SUBMIT_CLICK';
export const EVENT_HANDLE_SELECTED_CHANGE_MODEL_CLICK = 'EVENT_HANDLE_SELECTED_CHANGE_MODEL_CLICK';
export const EVENT_HANDLE_QUESTION_TYPE_CLICK = 'EVENT_HANDLE_QUESTION_TYPE_CLICK';
export const EVENT_HANDLE_SELECTED_CHANGE_MODEL = 'EVENT_HANDLE_SELECTED_CHANGE_MODEL';
export const EVENT_UPDATE_SELECTED_CHANGE_MODEL_IN_PREVIEW = 'EVENT_UPDATE_SELECTED_CHANGE_MODEL_IN_PREVIEW';
export const EVENT_HANDLE_SURVEY_FINISH_SELECTION = 'EVENT_HANDLE_SURVEY_FINISH_SELECTION';
export const EVENT_UPDATE_SURVEY_TITLE = 'EVENT_UPDATE_SURVEY_TITLE';
export const EVENT_RESET_SELECTED_CHANGE_MODEL = 'EVENT_RESET_SELECTED_CHANGE_MODEL';
export const EVENT_TOAST_MESSAGE = 'EVENT_TOAST_MESSAGE';
export const EVENT_ERROR_TOAST_MESSAGE = 'EVENT_ERROR_TOAST_MESSAGE';
export const EVENT_WARNING_TOAST_MESSAGE = 'EVENT_WARNING_TOAST_MESSAGE';
export const EVENT_LOGIN_TOAST_MESSAGE = 'EVENT_LOGIN_TOAST_MESSAGE';
export const EVENT_HANDLE_QUESTION_EDIT_LOGIC_CLICK = 'EVENT_HANDLE_QUESTION_EDIT_LOGIC_CLICK';
export const EVENT_HANDLE_ADD_ANSWER_IN_RIGHT_SIDE = 'EVENT_HANDLE_ADD_ANSWER_IN_RIGHT_SIDE';
export const EVENT_HANDLE_REMOVE_ANSWER_IN_RIGHT_SIDE = 'EVENT_HANDLE_REMOVE_ANSWER_IN_RIGHT_SIDE';
export const EVENT_HANDLE_ADD_QUESTION_TO_SURVEY_CLICK = 'EVENT_HANDLE_ADD_QUESTION_TO_SURVEY_CLICK';
export const EVENT_HANDLE_OPEN_SURVEY_MAP = 'EVENT_HANDLE_OPEN_SURVEY_MAP';
export const EVENT_HANDLE_NOT_SHOW_SURVEY_MAP = 'EVENT_HANDLE_NOT_SHOW_SURVEY_MAP';
export const EVENT_HANDLE_SURVEY_MAP_SCROLL_TO_QUESTION = 'EVENT_HANDLE_SURVEY_MAP_SCROLL_TO_QUESTION';
export const EVENT_HANDLE_POPUP_VISIBILITY = 'EVENT_HANDLE_POPUP_VISIBILITY';
export const EVENT_CONTENT_GROUP_QUESTION_CHANGE = 'EVENT_CONTENT_GROUP_QUESTION_CHANGE';
export const EVENT_CONTENT_RIGHT_ADD_QUESTION_TO_GROUP = 'EVENT_CONTENT_RIGHT_ADD_QUESTION_TO_GROUP';
export const EVENT_CONTENT_RIGHT_REMOVE_QUESTION_TO_GROUP = 'EVENT_CONTENT_RIGHT_REMOVE_QUESTION_TO_GROUP';
export const EVENT_TOGGLE_QUESTION_LIBRARY = 'EVENT_TOGGLE_QUESTION_LIBRARY';
export const EVENT_TOGGLE_CONFIGURE_SCORE = 'EVENT_TOGGLE_CONFIGURE_SCORE';
export const EVENT_CREATE_SURVEY_TAB_INACTIVE = 'EVENT_CREATE_SURVEY_TAB_INACTIVE';
export const EVENT_QUESTION_BUILDER_RESET_INVALID_ORDER = 'EVENT_QUESTION_BUILDER_RESET_INVALID_ORDER';
export const EVENT_RESET_CREATING_QUESTION = 'EVENT_RESET_CREATING_QUESTION';
export const EVENT_HANDLE_CANCEL_EDIT_QUESTION = 'EVENT_HANDLE_CANCEL_EDIT_QUESTION';

/* EVENT QUESTION LOGIC */
export const EVENT_GROUP_QUESTION_LOGIC_SAVE_LOGIC_BUTTON_STATUS = 'EVENT_GROUP_QUESTION_LOGIC_SAVE_LOGIC_BUTTON_STATUS';
export const EVENT_QUESTION_LOGIC_SAVE_LOGIC_BUTTON_STATUS = 'EVENT_QUESTION_LOGIC_SAVE_LOGIC_BUTTON_STATUS';
export const EVENT_QUESTION_LOGIC_ADD_CLICK = 'EVENT_QUESTION_LOGIC_ADD_CLICK';
export const EVENT_QUESTION_LOGIC_REMOVE_CLICK = 'EVENT_QUESTION_LOGIC_REMOVE_CLICK';
export const EVENT_HANDLE_QUESTION_DELETE_LOGIC_CLICK = 'EVENT_HANDLE_QUESTION_DELETE_LOGIC_CLICK';

/* Tab */
export const EVENT_TAB_ICON_RIGHT = 'EVENT_TAB_ICON_RIGHT';
export const EVENT_TAB_STEP_CLICK = 'EVENT_TAB_STEP_CLICK';
export const EVENT_TAB_STEP_PAGING_CLICK = 'EVENT_TAB_STEP_PAGING_CLICK';

/* slider question */
export const EVENT_VALIDATE_LEFT_VALUE = 'EVENT_VALIDATE_LEFT_VALUE';
export const EVENT_VALIDATE_RIGHT_VALUE = 'EVENT_VALIDATE_RIGHT_VALUE';
export const EVENT_UPDATE_VALUE_SLIDER = 'EVENT_UPDATE_VALUE_SLIDER';
export const EVENT_CANCLE_SLIDER_QUESTION = 'EVENT_CANCLE_SLIDER_QUESTION';

export const EVENT_HANDLE_SELECTED_CATEGORY_IN_MODAL = 'EVENT_HANDLE_SELECTED_CATEGORY_IN_MODAL';

/* calculate variable */
export const EVENT_SHOW_TO_END_USER = 'EVENT_SHOW_TO_END_USER';
export const EVENT_ERROR_CALCULATE_VARIABLE = 'EVENT_ERROR_CALCULATE_VARIABLE';

/* page break */
export const EVENT_ERROR_PAGE_BREAK = 'EVENT_ERROR_PAGE_BREAK';

export const EVENT_RELOAD_SURVEY = 'EVENT_RELOAD_SURVEY';
